<div class="card">
  <div class="card-header flex" i18n="@@InvoiceHeader">
    <h5>
      <app-svg source="icons/feather/file-letter" height="18"></app-svg>
      Rechnungen
    </h5>
    <!-- <button type="button" class="btn btn-yellow mb-3" (click)="getInvoicePDF()">Get Invoice</button> -->
  </div>

  <div class="card-body">
    <div *ngIf="tableReady" [class]="tableView">
      <app-table [id]="className + 'Table'" [table]="table" [class]="tableFunctions.getTableLayout(className)"></app-table>
    </div>
  
    <div *ngIf="!tableReady" class="loading-spinner-container">
      <div class="spinner-border text-primary loading-spinner-md" role="status">
        <span class="visually-hidden-focusable" i18n="@@Loading">Loading...</span>
      </div>
    </div>
  </div>

  <div class="card-footer" *ngIf="invoices.length > 10 && !isOperator">
    <ng-container *ngTemplateOutlet="defaultFooter"></ng-container>
  </div>
</div>

<ng-template #defaultFooter>
  <div class="d-flex">
    <div class="flex-fill d-none d-md-inline">
      <div class="d-flex">
        <div class="flex p-2" i18n="@@ElementsPerPage">Elemente pro Seite</div>
        <div class="flex">
          <select id="pageSize"
                  name="pageSize"
                  [(ngModel)]="tableFunctions.pageSize"
                  class="form-control form-select custom-select"
                  aria-label=""
                  (change)="tableFunctions.onPageSizeChange(activeComponentClassName)">
            <option [ngValue]="10">10</option>
            <option [ngValue]="25">25</option>
            <option [ngValue]="50">50</option>
            <option [ngValue]="100">100</option>
            <option [ngValue]="250">250</option>
          </select>
        </div>
      </div>
    </div>
    <div class="d-flex d-md-inline-flex flex-fill text-center justify-content-center">
      <ngb-pagination #pagination
                      [collectionSize]="(tableFunctions.total$ | async)!"
                      [(page)]="tableFunctions.page"
                      [pageSize]="tableFunctions.pageSize"
                      [maxSize]="tableFunctions.page == 4 ? 4 : 3"
                      [boundaryLinks]="true"
                      [rotate]="true">
      </ngb-pagination>
    </div>
    <div class="flex-fill justify-content-end d-none d-md-inline">
      <div class="d-flex float-end">
        <div class="flex p-2" i18n="@@GoToPage">Springe zu Seite</div>
        <div class="flex">
          <select id="page" name="page" [(ngModel)]="tableFunctions.page" class="form-control form-select" aria-label="">
            <option *ngFor="let page of [].constructor(pagination.pageCount); let i = index" [ngValue]="i + 1">{{ i + 1 }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<router-outlet></router-outlet>
